export default __webpack_public_path__ + "static/media/MoonIcon.55ed71be.svg";